import { AppConsts } from '@shared/AppConsts';
import { IThemeAssetContributor } from '../ThemeAssetContributor';

export class Theme10ThemeAssetContributor implements IThemeAssetContributor {
    getAssetUrls(): string[] {
        return [AppConsts.appBaseUrl + '/assets/fonts/fonts-asap-condensed.min.css'];
    }
}
